import { first } from 'lodash'
import { GeneralAPI } from '../apis/GeneralAPI'
import { Container } from '../components/Container'
import Header from '../components/Header'
import { ParseWordPressHTML } from '../helpers/utils'

export default function PrivacyPolicy({ data }) {
    return (
        <div>
            <Header meta={data.yoast_head} />

            <Container>
                <div className="flex flex-col">
                    <ParseWordPressHTML>
                        {data.content.rendered}
                    </ParseWordPressHTML>
                </div>
            </Container>
        </div>
    )
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps() {
    const data = first(await GeneralAPI.getPageBySlug('privacy-policy'))

    if (!data) {
        return {
            notFound: true,
            revalidate: 10,
        }
    }

    return {
        props: {
            data,
        },
        revalidate: 10, // In seconds
    }
}
